var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBergurMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 20,
    height: 20,
    transform: "translate(307 21)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-307 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(305 19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M21.333,19.333H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,1,1,0,1.333Z",
    fill: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M21.333,12.667H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,0,1,0,1.333Z",
    fill: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M21.333,6H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,0,1,0,1.333Z",
    fill: "var(--secondary-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergurMenu);
export default __webpack_public_path__ + "static/media/bergur-menu.371ece06fcb83c4b2230aa40c9bb3417.svg";
export { ForwardRef as ReactComponent };